module.exports = __webpack_public_path__ + "static/img/4.a6971b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/medio-ambiente/4.png
// module id = CSdQ
// module chunks = 0